import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {
  ActionResult,
  ActionResultList, ImportConfirmation,
  PagedFilter, RegistrationFilter, RaceRegistration, StatementFileImport,
  StatementImport, StatementImportFilter,
  StatementImportItem,
} from "@model";
import {Observable, map} from "rxjs";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class AccountStatementsService {

  constructor(private http: HttpClient, private environmentService:EnvironmentService) {
  }

  findImports(filter: PagedFilter<StatementImportFilter> | undefined): Observable<StatementImport[]> {
    return this.http.post<ActionResultList<StatementImport[], number>>(this.environmentService.getApiUrl() + "/api/bank-trasfer/import", filter).pipe(
      map((actionResult: ActionResultList<StatementImport[], number>) => {
        return actionResult.resultCode !== -1 && actionResult.result ? actionResult.result : [];
      }));
  }

  findImportItems(importId: number): Observable<StatementImportItem[]> {
    return this.http.get<ActionResultList<StatementImportItem[], number>>(this.environmentService.getApiUrl() + "/api/bank-trasfer/import/" + importId).pipe(
      map((actionResult: ActionResultList<StatementImportItem[], number>) => {
        return actionResult.resultCode !== -1 && actionResult.result ? actionResult.result : [];
      }));
  }

  uploadSignedStatementFileImport(fileImport: StatementFileImport, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/xml/signed", fileImport)
      .subscribe((actionResult: ActionResult<boolean>): void => {
        actionResult.resultCode !== -1 ? onSuccess() : onError();
      });
  }

  uploadStatementFileImport(fileImport: StatementFileImport, isSigned: boolean, onSuccess: () => void, onError: () => void): void {
    const endpointUrl = isSigned ? '/api/bank-trasfer/xml/signed' :  '/api/bank-trasfer/xml/raw'
    this.http.post<ActionResult<boolean>>
    (this.environmentService.getApiUrl() + endpointUrl, fileImport)
      .subscribe((actionResult: ActionResult<boolean>): void => {
        actionResult.resultCode !== -1 ? onSuccess() : onError();
      });
  }

  confirmImport(importConfirmation: ImportConfirmation, onSuccess: (statementImport: StatementImport) => void, onError: () => void): void {
    this.http.post<ActionResult<StatementImport>>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/import/confirm", importConfirmation)
      .subscribe((actionResult: ActionResult<StatementImport>): void => {
        actionResult.resultCode !== -1 && actionResult.result ? onSuccess(actionResult.result) : onError();
      });
  }

  deleteImport(importConfirmation: ImportConfirmation, onSuccess: () => void, onError: () => void): void {
    this.http.post<ActionResult<StatementImport>>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/import/delete", importConfirmation)
      .subscribe((actionResult: ActionResult<StatementImport>): void => {
        actionResult.success ? onSuccess() : onError();
      });
  }

  findMatchingRegistrations(filter: PagedFilter<RegistrationFilter> | undefined): Observable<RaceRegistration[]> {
    return this.http.post<ActionResultList<RaceRegistration[], number>>(this.environmentService.getApiUrl() + "/api/bank-trasfer/registrations", filter).pipe(
      map((actionResult: ActionResultList<RaceRegistration[], number>) => {
        return actionResult.resultCode !== -1 && actionResult.result ? actionResult.result : [];
      }));
  }

  connectImportAndRegistration(items: StatementImportItem[], onSuccess: () => void): void {
    this.http.post<void>
    (this.environmentService.getApiUrl() + "/api/bank-trasfer/connect", items)
      .subscribe((): void => {
        onSuccess();
      });
  }
}
